<!-- COMPONENTE PARA ADICIONAR ITENS AO PEDIDO

- pesquisa itens pela descricao ou pelo codigo
- digitacao de quantidade, desconto, preço para inclusao no pedido
- botao adicionar itens

- pesqiosa itens pela tabela de destaque



- params:
{
    pedv: {},                     //dados do pedido
    produtosDestaque: false,      //lista produtos da tabela de destaque
}

-->

<script>
import { SysVars } from '../main';
import Trap from 'vue-focus-lock'
import grade from '../components/grade'
import { apiORDS } from '../shared/api-functions'

export default {
  props: {
    params: Object
  },

  data() {
    return {
      searchString: '',
      inicio: true,
      noItems: false,
      showItems: false,
      errorMessage: '',
      error: false,
      localItemList: [],
      topAdicionar: null,
      leftAdicionar: null,
      scrollY: 0,
      myStyle: {},
      unWatch: false,
      showItemLote: false,
      itemKit: null,
      pesquisaCodigo: false,
      offset: false,
    }
  },

  computed: {

    nextPage: function () {
      return this.$store.getters.getNextPage
    },

    itemList: function () {
      return this.$store.getters.getItemSalesList
    },

    metadata: function () {
      return this.$store.getters.getEntities.metadata
    },

    myDropDown: function () {
      // console.log(this.$refs.pesquisa.getBoundingClientRect())
      // const rect = this.$refs.pesquisa.getBoundingClientRect();
      // return 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
      //return 'top: 764.297px; left: 235px;'
    },

    bloqueia_preco_item: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_preco_item
      else
        return false
    },


  },

  methods: {
    handleMore() {
      this.offset = true
      this.loadData()
    },


    label_tabdesc: function (value) {
      return "Tab. Desconto: " + value;
    },

    scrollTop() {

    },

    handleShowItemLote(div) {
      jQuery("#" + div).show();
    },

    addItens() {
      //botao adicionar itens
      //valida o preço dos itens e quantidades informadas
      //emite o evento additem com a lista de itens que deverão ser adicionados
      var selectedItems = []
      this.error = false
      for (var x = 0; x < this.localItemList.length; x++) {
        //CHECA SE O ITEM POSSUI QUANTIDADE INFORMADA PARA ADICIONAR NO PEDIDO
        if (this.localItemList[x].qtuni != null && this.localItemList[x].qtuni != 0) {
          if (!this.localItemList[x].vlr || this.localItemList[x].vlr <= 0) {
            this.localItemList[x].error = 'Necessário informar o preço do item'
            this.error = true
          } else {
            this.localItemList[x].error = false
            selectedItems.push(this.localItemList[x])
          }
        }
      }

      let lixo = [...this.localItemList] //// ALTERACAO NO this.localItemList[x].error NAO ESTA RENDERIZANDO
      this.localItemList = []
      this.localItemList = lixo ///////////////

      if (!this.error) {
        this.handleEsc()
        this.$emit('additem', selectedItems)
        this.focus()
      } else {
        this.$erpToastError('Erro. Alguns itens estão sem valor!')
      }

    },

    handleEsc() {
      this.noItems = false
      this.showItems = false
      this.searchString = ''
      if (this.$refs.pesquisa)
        this.focus()

      if (this.params.produtosDestaque) {
        this.closeForm()
      }
    },

    handleEnter(index) {
      if (index + 1 == this.itemList.length) {
        this.addItens()
      }
    },

    handleUpdateGrade(index, qt, listItemGrade) {
      //QUANDO FOR DIGITADA QUANTIDADE NA GRADE DO PRODUTO
      this.localItemList[index].qtuni = qt
      this.localItemList[index].pedvgrade = listItemGrade
    },

    focus() {
      this.$nextTick(function () {
        this.$refs.searchpedidoaddlist.focus()
      })
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleChange() {
      // console.log(this.searchString)
      if (!this.searchString) {
        this.noItems = false
        this.showItems = false
        return
      }
    },

    search() {
      //efetua a pesquisa por descricao ou por codigo
      this.inicio = false

      // if (!this.searchString) {
      //     this.showItems = false
      //     return
      // }

      if (this.params.produtosDestaque) {
        this.filter = ''
      } else {
        this.searchString = this.searchString.toUpperCase()
        if (this.searchString.length <= 0) return;
        if (this.pesquisaCodigo)
          this.filter = '{"codigo":{"$eq":"' + this.searchString + '"}}'
        else
          this.filter = '{"descricao":{"$or":[{"$like":"%25' + this.searchString + '%25"},{"codigo":{"$eq":"' + this.searchString + '"}}]}}'
      }

      this.loadData()
    },

    loadData() {
      let params = {
        codtabpre: this.params.pedv.codtabpre,
        codpedv: this.params.pedv.codpedv,
        filter: this.filter,
        produtosDestaque: this.params.produtosDestaque
      }
      if (this.offset) {
        params.offset = this.nextPage
      }

      this.unWatch = false
      this.$store.dispatch('loadItemSales', params)
      this.offset = false
    },

    async getKitDetails(coditem) {
      const codtabpre = this.params.pedv.codtabpre
      const url = `item/kit/${coditem}/tabpre/${codtabpre}/`


      const data = await apiORDS(this.$store.getters.urlOrds + url)

      if (data.items) {
        data.items.map(i => {
          if (i.itemlote_json) {
            i.itemlote_json = JSON.parse(i.itemlote_json)
          }
        })

        this.localItemList.map(i => {
          if (i.coditem == coditem) {
            this.$set(i, 'itemKit', data.items)
          }
        })
      }
    },


  },

  watch: {

    itemList: function () {
      if (this.inicio || this.unWatch) {
        return
      }

      this.unWatch = true

      if (!this.itemList.length) {
        this.noItems = true
        this.showItems = false
      } else {
        this.noItems = false
        this.showItems = true

        //JOGA O FOCO PARA O PRIMEIRO ITEM DA PESQUISA
        this.$nextTick(function () {
          // console.log(this.$refs.grade)
          // console.log(this.$refs.qtuni)
          // console.log(this.itemList[0])
          if (this.itemList[0].isgrade == 'S' || this.$refs.grade) {
            this.$refs.grade[0].focus()
          } else
            if (this.$refs.qtuni.length) {
              this.$refs.qtuni[0].focus()
            }
        })
      }

      //adiciona o objeto PEDVIT à lista de itens local
      this.localItemList = [...this.itemList]
      let vm = this
      let param = this.params
      jQuery.map(this.localItemList, function (value) {
        if (typeof value.unimed !== 'object') {
          // value.pedvit = {...vm.$store.getters.getEntities.pedvit}
          value.grade = []  //A GRADE VAI COLOCAR OS ITENS DIGITADOS AQUI
          value.uni = value.uni
          value.vlr = value.vlrtab
          value.pdesc1 = null
          value.pdesc2 = null
          value.pdesc3 = null
          value.pdesc4 = null
          value.pedcliit = null
          if (value.unimed)
            value.unimed = JSON.parse(value.unimed)
          value.error = false
          if (value.tabelas_desconto)
            value.tabelas_desconto = JSON.parse(value.tabelas_desconto)
          if (value.tabelas_preco)
            value.tabelas_preco = JSON.parse(value.tabelas_preco)
          if (value.itemlote_json)
            value.itemlote_json = JSON.parse(value.itemlote_json)
          if (value.estoque_kit_json)
            value.estoque_kit_json = JSON.parse(value.estoque_kit_json)
          //CARREGA O DESCONTO INFORMADO NO PEDIDO
          if (param) {
            if (param.pedv.pdesc1) {
              value.pdesc1 = param.pedv.pdesc1
            }
            if (param.pedv.pdesc2) {
              value.pdesc2 = param.pedv.pdesc2
            }
            if (param.pedv.pdesc3) {
              value.pdesc3 = param.pedv.pdesc3
            }
            if (param.pedv.pdesc4) {
              value.pdesc4 = param.pedv.pdesc4
            }
          }
        }
        return value
      })

    },

    scrollY: function () {
      //EFETUA O CONTROLE DA BARRA DE PESQUISA EM RELAÇÃO AO SCROLL DA TELA
      if (!this.showItems)
        return

      if (!this.leftAdicionar && this.$refs.adicionar)
        this.leftAdicionar = this.$refs.adicionar.$el.getBoundingClientRect().left;

      const rect = this.$el.getBoundingClientRect();
      const newTop = this.scrollY; // - this.topAdicionar;

      // console.log('posicao inicial: ' + this.topAdicionar)
      // console.log('posicao top: ' + rect.top)
      // console.log('posicao left: ' + this.leftAdicionar)

      if (rect.top < -50) {
        this.$set(this.myStyle, 'top', 0);
        this.$set(this.myStyle, 'left', this.leftAdicionar);
        this.$set(this.myStyle, 'position', 'fixed');
        //this.$delete(this.myStyle, 'margin-left');
        // console.log(this.myStyle)
      } else {
        this.$delete(this.myStyle, 'top');
        this.$delete(this.myStyle, 'position');
        this.$delete(this.myStyle, 'left');
      }

    }
  },

  components: {
    grade, Trap
  },

  created() {
    //this.$store.dispatch('clearItemSales')

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },

  mounted() {
    // console.log(this.$el)

    this.topAdicionar = this.$el.getBoundingClientRect().top;

    window.addEventListener('scroll', (event) => {
      this.scrollY = Math.round(window.scrollY);
      // console.log(this.scrollY)
    });

    if (this.params.produtosDestaque) {
      this.inicio = false
      this.loadData()
      return
    }
    this.$refs.searchpedidoaddlist.focus()

  }

}

</script>

<template>

  <section>

    <div class="mb-2">
      <div v-if="!params.produtosDestaque" class="headerpesquisa"
        style="position: relative; width: 100%; z-index: 10; background-color: white">
        <!-- <label-title icon="fa-search" title="Pesquisar Produtos"></label-title> -->
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="input-group input-group-sm">
              <input ref="searchpedidoaddlist" class="form-control form-control-sm" id="search-pedido-addlist"
                type="text" placeholder="Pesquisa pela descrição ou pelo código do item" v-model="searchString"
                @change="handleChange()" @keyup.esc="handleEsc()" @keyup.enter="search()">
              <span class="input-group-append">
                <button class="btn btn-sm btn-outline-secondary" tabindex="1" style="margin-right: 5px" type="submit"
                  @click="search()">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <input-checkbox v-model="pesquisaCodigo" :value-checked="true" :value-unchecked="false"
              label="Pesquisar somente por código"></input-checkbox>
          </div>
        </div>
      </div>
      <div v-if="noItems" class="dropdown-select-item" style="min-width: 50%" :style="myDropDown"
        @keyup.esc="handleEsc()">
        <span class="lbl">Nenhum item foi encontrado</span>
      </div>
    </div>

    <div v-if="showItems" class="nb-modal-scrollable">
      <Trap>
        <div class="nb-modal-scrollable-container add-itens" style="" @keyup.esc="handleEsc()">
          <div class="add-itens-inner">
            <div class="add-itens-header sticky p-2">
              <div class="w-100">
                <button type="button" class="close" @click="handleEsc()"><span
                    aria-hidden="true">&times;</span></button>
                <h4 class="def-title pt-2">Pesquisa de Produtos</h4>
              </div>
            </div>
            <div class="add-itens-body">
              <div v-for="(item, index) in localItemList" v-bind:key="index">
                <div style="border: 1px solid #f9f9f9; margin-bottom: 10px;">
                  <div style="background: #f9f9f9; padding: 10px; margin-bottom: 10px;">
                    <div class="row">
                      <div class="col-md-12">
                        <span class="lbl-title-produto">{{ item.descricao }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <v-label label="Código: " class="my-0"></v-label>
                        <span class="data-list my-0">{{ item.codigo }}</span>
                        <span v-if="item.existe" class="badge badge-yellow">Adicionado</span>
                      </div>
                    </div>
                    <div class="row align-items-start py-2">
                      <div class="col-md-3 col-3 d-flex flex-column">
                        <v-label label="Preço"></v-label>
                        <span class="data-list" v-if="item.vlrtab">R$ {{ item.vlrtab | formatValue(2) }}</span>
                        <span v-if="item.desconto_tabela > 0" class="badge badge-yellow"> Desconto em Tabela -{{
                            item.desconto_tabela
                        }}% </span>
                      </div>
                      <div class="col-md-4 col-4">
                        <v-label label="Estoque"></v-label>

                        <div>
                          <span v-if="item.itemlote_qt == 0 && item.iskit != 'S'" class="data-list">
                            {{ item.saldo_estoque }}
                          </span>

                          <span v-if="item.itemlote_qt == 0 && item.iskit == 'S'" class="data-list">
                            {{ item.saldo_estoque }}

                            <a v-if="item.estoque_kit_json && item.estoque_kit_json.itemlotes && item.estoque_kit_json.itemlotes.length"
                              aria-controls="collapseExample" aria-expanded="false" data-toggle="collapse"
                              :href="`#div_itemkitlotes_${item.coditem}`" role="button">
                              <i class="fa fa-caret-down ml-2" aria-hidden="true"></i>
                              Lotes
                            </a>
                          </span>

                          <span v-if="item.itemlote_qt > 0 && item.itemlote_json.itemlotes.length" class="data-list">
                            {{ item.saldo_estoque }}

                            <a aria-controls="collapseExample" aria-expanded="false" data-toggle="collapse"
                              :href="`#div_itemlotes_${item.coditem}`" role="button">
                              <i class="fa fa-caret-down ml-2" aria-hidden="true"></i>
                              Lotes
                            </a>
                          </span>

                        </div>
                      </div>
                      <div class="col-md-2 col-2" data-toggle="tooltip" data-placement="top"
                        title="Ver composição do Kit">
                        <button :tabindex="-1" class="btn btn-outline-secondary btn-sm"
                          @click="getKitDetails(item.coditem)" v-if="item.iskit == 'S'" data-toggle="collapse"
                          :href="`#multiCollapseExample${item.coditem}`" role="button" aria-expanded="false"
                          :aria-controls="`multiCollapseExample${item.coditem}`">
                          <i class="fa fa-cubes"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style="background: #f9f9f9; padding: 10px; margin-top: -10px;" class="collapse"
                    :id="`multiCollapseExample${item.coditem}`">
                    <div class="row" v-if="item.itemKit" v-for="(kit, index) in item.itemKit" :key="index">
                      <div class="col-md-6">
                        <v-label label="Descrição" v-if="index == 0"></v-label>
                        <span class="data-list w-100 text-dark">{{ kit.descricao }} {{ kit.descricaolinha }} {{
                            kit.descricaocoluna
                        }}</span>
                      </div>
                      <div class="col-md-2 d-flex flex-column">
                        <v-label label="Quantidade" v-if="index == 0"></v-label>
                        <span class="lbl">{{ kit.qt }} {{ kit.uni }}</span>
                      </div>
                      <div class="col-md-2 d-flex flex-column">
                        <v-label label="Saldo Estoque" v-if="index == 0"></v-label>
                        <span class="lbl">{{ kit.saldo_estoque }}
                          <a aria-controls="collapseExample" aria-expanded="false" data-toggle="collapse"
                            :href="`#div_itemkitestoque_${item.coditem}_${index}`" role="button">
                            <i class="fa fa-caret-down ml-2" aria-hidden="true"></i>
                            Lotes
                          </a>

                        </span>

                      </div>

                      <div style="background: #f9f9f9; padding: 10px; margin-top: -10px;" class="collapse"
                        :id="`div_itemkitestoque_${item.coditem}_${index}`">
                        <span class="lbl-title-produto mb-3">Lotes de Estoque</span>
                        <div>
                          <div class="row align-items-center">
                            <div class="col-md-6 col-6">
                              <v-label label="Depósito"></v-label>
                            </div>
                            <div class="col-md-6 col-6">
                              <v-label label="Quantidade"></v-label>
                            </div>
                          </div>

                          <div v-if="kit.itemlote_json && kit.itemlote_json.itemlotes"
                            v-for="(itemlote, indexitemlote) in kit.itemlote_json.itemlotes" v-bind:key="indexitemlote">
                            <div class="row align-items-center">
                              <div class="col-md-6 col-6">
                                <span class="data-list">{{ itemlote.coddeposito }}</span>
                              </div>
                              <div class="col-md-6 col-6">
                                <span class="data-list">{{ itemlote.qt }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>

                  </div>
                  <div class="collapse" :id="`div_itemlotes_${item.coditem}`" style="padding: 10px">
                    <span class="lbl-title-produto mb-3">Lotes de Estoque</span>
                    <div v-if="item.itemlote_qt > 0">
                      <div class="row align-items-center">
                        <div class="col-md-2 col-2">
                          <v-label label="Depósito"></v-label>
                        </div>
                        <div class="col-md-2 col-2">
                          <v-label label="Lote"></v-label>
                        </div>
                        <div class="col-md-2 col-2">
                          <v-label label="Sublote"></v-label>
                        </div>
                        <div class="col-md-2 col-2">
                          <v-label label="Lote Fornecedor"></v-label>
                        </div>
                        <div class="col-md-2 col-2">
                          <v-label label="Validade"></v-label>
                        </div>
                        <div class="col-md-2 col-2">
                          <v-label label="Quantidade"></v-label>
                        </div>
                      </div>

                      <div v-for="(itemlote, indexlote) in item.itemlote_json.itemlotes" v-bind:key="indexlote">
                        <div class="row align-items-center">
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.coddeposito }}</span>
                          </div>
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.lote }}</span>
                          </div>
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.sublote }}</span>
                          </div>
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.lotefornecedor }}</span>
                          </div>
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.dtvalidade | formatData }}</span>
                          </div>
                          <div class="col-md-2 col-2">
                            <span class="data-list">{{ itemlote.qt }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="item.estoque_kit_json && item.estoque_kit_json.itemlotes && item.estoque_kit_json.itemlotes.length"
                    class="collapse" :id="`div_itemkitlotes_${item.coditem}`" style="padding: 10px">
                    <span class="lbl-title-produto mb-3">Lotes de Estoque</span>
                    <div v-if="item.itemlote_qt == 0">
                      <div class="row align-items-center">
                        <div class="col-md-4 col-6">
                          <v-label label="Depósito"></v-label>
                        </div>
                        <div class="col-md-4 col-6">
                          <v-label label="Quantidade"></v-label>
                        </div>
                      </div>

                      <div v-for="(itemlote, indexlote) in item.estoque_kit_json.itemlotes" v-bind:key="indexlote">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-6">
                            <span class="data-list">{{ itemlote.coddeposito }}</span>
                          </div>
                          <div class="col-md-4 col-6">
                            <span class="data-list">{{ itemlote.qt }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="padding: 10px;">
                    <div class="row" v-if="item.isgrade == 'S'">
                      <div class="col">
                        <grade ref="grade"
                          :params="{ view: false, coditem: item.coditem, index: index, qt: item.qtuni, listItemGrade: item.grade }"
                          @update="handleUpdateGrade"></grade>
                      </div>
                    </div>
                    <div class="row">
                      <form-field v-if="item.isgrade != 'S'" ref="qtuni" v-model="item.qtuni" type="value" col="3"
                        :metadata="metadata.pedvit.qtuni"></form-field>
                      <form-field v-if="!bloqueia_preco_item" v-model="item.vlr" type="value" col="3"
                        :metadata="metadata.pedvit.vlr" @keyenter="handleEnter(index)" preaddon="R$"
                        :disabled="item.iskit === 'S' ? true : false"></form-field>
                      <div v-else class="col-md-3 col-4">
                        <v-label :metadata-field="metadata.pedvit.vlr"></v-label>
                        <strong class="lbl w-100">R$ {{ item.vlr | formatValue(2) }}</strong>
                      </div>
                      <form-field v-model="item.uni" :tabindex="-1" type="select2" col="3"
                        :metadata="metadata.pedvit.uni" v-if="item.unimed && item.unimed.length > 0" name="uni"
                        :v-errors="errors" v-validate="metadata.pedvit.uni.validator"></form-field>
                      <!-- <form-field v-model="item.vlrtab" type="value" col="3" :disabled="true" :metadata="metadata.pedvit.vlrtab" preaddon="R$"></form-field> -->
                      <form-field :tabindex="((item.iskit != 'S') ? -1 : 0)" v-model="item.pdesc1" type="value" col="2"
                        :metadata="metadata.pedvit.pdesc1"></form-field>
                      <form-field :tabindex="((item.iskit != 'S') ? -1 : 0)" v-model="item.pdesc2" type="value" col="2"
                        :metadata="metadata.pedvit.pdesc2"></form-field>
                      <form-field :tabindex="((item.iskit != 'S') ? -1 : 0)" v-model="item.pdesc3" type="value" col="2"
                        :metadata="metadata.pedvit.pdesc3"></form-field>
                      <!-- <form-field :tabindex="((item.iskit != 'S')?-1:0)" v-model="item.pdesc4" type="value" col="2" :metadata="metadata.pedvit.pdesc4"></form-field> -->
                      <form-field :tabindex="((item.iskit != 'S') ? -1 : 0)" v-model="item.pedcliit" type="value"
                        col="3" :metadata="metadata.pedvit.pedcliit"></form-field>

                    </div>
                    <div class="row col" v-if="item.error">
                      <span class="error">{{ item.error }}</span>
                    </div>
                    <div class="row" v-if="item.tabelas_desconto">
                      <form-field v-for="(desconto, index) in item.tabelas_desconto.descontos" :key="index"
                        :tabindex="-1" v-model="desconto.pdesc" type="value" col="3" :precision="2"
                        :label="label_tabdesc(desconto.descricao)" addon="%"></form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center p-3 ">
                <a v-if="nextPage > 0" class="btn btn-primary" @click="handleMore()">Exibir mais</a>
              </div>

            </div>
            <div class="add-itens-footer">
              <div class="d-flex">
                <v-button :nb-btdef="true" :tabindex="1" @click="addItens()" class="ml-auto p-2" icon="fa-plus"
                  label="Adicionar" ref="adicionar" title="Adiciona no pedido os itens selecionados abaixo">
                </v-button>
              </div>
            </div>
          </div>
        </div>
      </Trap>
    </div>

  </section>

</template>





<style>
.add-itens {
  display: flex;
  background-color: #fff;
  top: 0;
  height: 100%;
  overflow: hidden;
  width: 800px;
  max-width: 100%
}

.add-itens-inner {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.add-itens-header {
  border-bottom: 1px solid #e9ecef;
}

.add-itens-body {
  overflow-x: hidden;
  height: 100%;
}




.dropdown-select-item {
  z-index: 1051;
  margin-top: 3px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;

  position: absolute;
  padding: 10px;
  /* top: 100%;
    left: 0; */
  z-index: 1000;
  /* display: none; */
  float: left;
  min-width: 160px;
  /* margin: 2px 0 0; */
  list-style: none;
  background-color: #fff;
  /* border: 1px solid #ccc; */
  border: 1px solid rgba(0, 0, 0, 0.2);
  /* *border-right-width: 2px;
    *border-bottom-width: 2px;
    -webkit-border-radius: 6px; */
  /* -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    -moz-box-shadow: 0 5px 10px rgba(0,0,0,0.2); */
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  /* -webkit-background-clip: padding-box;
    -moz-background-clip: padding; */
  background-clip: padding-box;
}
</style>



// WEBPACK FOOTER //
// src/forms/pedido-addlist.vue